'use client'

import React from 'react'
import { Card, CardContent } from '@/components/ui/card'

/**
 * 리스트 스켈레톤 컴포넌트
 */
export const ListSkeleton: React.FC<{ rows?: number }> = ({ rows = 6 }) => {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <Card key={i}>
          <CardContent className="p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="space-y-2 flex-1">
                <div className="h-4 w-56 bg-gray-200 rounded animate-pulse" />
                <div className="h-3 w-40 bg-gray-200 rounded animate-pulse" />
                <div className="h-3 w-28 bg-gray-200 rounded animate-pulse" />
              </div>
              <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}

/**
 * 상세 스켈레톤 컴포넌트
 */
export const DetailSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="h-6 w-52 bg-gray-200 rounded animate-pulse" />
        <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse" />
      </div>
      <div className="h-24 w-full bg-gray-200 rounded-lg animate-pulse" />
      <div className="h-40 w-full bg-gray-200 rounded-lg animate-pulse" />
    </div>
  )
}

/**
 * 레거시 호환을 위한 별칭
 */
export const QuoteListSkeleton = ListSkeleton
export const QuoteDetailSkeleton = DetailSkeleton

